import { combineReducers } from 'redux';

import dirtyStates from './dirty-states';
import models from './models';

export const reducers = combineReducers({
	dirtyStates,
	models,
});
